export function openLink(link: string) {
  // Safari is blocking any call to window.open() which is made inside an async call
  // TODO: find another way
  const a = document.createElement('a');
  a.setAttribute('href', link);
  a.setAttribute('target', '_blank');
  a.click();
}
